'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const HosStatusDurations=require('../../../dist-es6/client/dtos/hosStatusDurations');
const FatigueMeterType=require('../../../dist-es6/shared/domain/fatigueMeterType');
const LastKnownStatus=require('pulsar-fatigue/dist-es6/domain/lastKnownStatus');
const timespan=require('pulsar-utils/dist-es6/time/timespan');
const SocketResponse=require('../../../dist-es6/client/dtos/socketResponse');let

StatisticsService=function(_BaseService){_inherits(StatisticsService,_BaseService);_createClass(StatisticsService,null,[{key:'$inject',get:function()
{return['socketService','userService']}}]);

function StatisticsService(socketService,userService){_classCallCheck(this,StatisticsService);var _this=_possibleConstructorReturn(this,
_BaseService.call(this));
_this._socketService=socketService;
_this._userService=userService;return _this;
}StatisticsService.prototype.

getPersonalStatisticsFor=function(){var ref=_asyncToGenerator(function*(personInfo,queryInterval,timezone){
const fatigueMeterType=_.get(this._userService,'currentUser.fatigueMeterType');

let statisticsRequest={
personInfo:personInfo,
queryInterval:queryInterval,
timezone:timezone,
requestedStats:[
'lastKnownStatus',
'dailyFatigueSummaries',
'dailyStatusSummaries',
'dutyHours']};



if(fatigueMeterType===FatigueMeterType.Trucking){
_.pushMany(statisticsRequest.requestedStats,['numTripsOnDuty','timeOfLastHosStatus']);
}

if(fatigueMeterType===FatigueMeterType.Workforce){
_.pushMany(statisticsRequest.requestedStats,['numDuties']);
}

let personalStatistics=yield this._socketService.sendAndWaitForResponse('GetPersonalStatistics',statisticsRequest);

personalStatistics.queryInterval=new TimeInterval(personalStatistics.queryInterval);
personalStatistics.lastKnownStatus=LastKnownStatus.fromJSON(personalStatistics.lastKnownStatus);
personalStatistics.timeOfLastHosStatus=SocketResponse.safeDeserializeDate(personalStatistics.timeOfLastHosStatus);

if(_.exists(personalStatistics.dailyStatusSummaries)){
let hasDrivingOffDutyDay=!1;
personalStatistics.dailyStatusSummaries=personalStatistics.dailyStatusSummaries.map(function(statusSummary){
const durations=HosStatusDurations.fromJSON(statusSummary);
if(durations.drivingOffDuty.totalMilliseconds()>0){
hasDrivingOffDutyDay=!0;
}
return{
onDuty:durations.onDuty,
offDuty:timespan.fromMilliseconds(durations.offDuty.totalMilliseconds()+durations.drivingOffDuty.totalMilliseconds()),
drivingOffDuty:durations.drivingOffDuty,
driving:durations.driving,
sleeperBerth:durations.sleeperBerth,
onDutyOrDriving:timespan.fromMilliseconds(durations.onDuty.totalMilliseconds()+durations.driving.totalMilliseconds())};

});
personalStatistics.dailyStatusSummaries.hasDrivingOffDutyDay=hasDrivingOffDutyDay;
}

return personalStatistics;
});function getPersonalStatisticsFor(personInfo,queryInterval,timezone){return ref.apply(this,arguments)}return getPersonalStatisticsFor}();return StatisticsService}(BaseService);


module.exports=StatisticsService;
//# sourceMappingURL=statisticsService.js.map
